// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"373":"342b4ee1","453":"d855a71b","531":"f7f37c61","578":"d4874308","606":"b4a25f34","817":"c77eb27a"}[chunkId] + ".chunk.js";
};